import { z } from "zod";

// Field names are backend cascade-delete targets, never read individually
// on the frontend — only summed for a total (see PreviewSummaryTable).
const CascadeCountsSchema = z.record(z.string(), z.number());

const RegionMergePreviewSchema = z.object({
  region: z.string(),
  source_found: z.boolean(),
  target_found: z.boolean(),
  image_object_type_reassign_count: z.number(),
  image_object_type_conflict_count: z.number(),
  dataset_meta_count: z.number(),
  defect_dataset_meta_count: z.number(),
  dataset_type_conversion_count: z.number(),
  client_object_type_map_count: z.number(),
  dppower_map_count: z.number(),
  cascade_counts: CascadeCountsSchema,
});

export type RegionMergePreview = z.infer<typeof RegionMergePreviewSchema>;

export const ObjectTypeMergePreviewSchema = z.object({
  regions: z.array(RegionMergePreviewSchema),
});

export type ObjectTypeMergePreview = z.infer<typeof ObjectTypeMergePreviewSchema>;

const RegionMergeResultSchema = z.object({
  region: z.string(),
  status: z.enum(["merged", "already_merged", "error"]),
  error: z.string().nullable(),
  image_object_type_reassigned: z.number(),
  image_object_type_conflicts_removed: z.number(),
  dataset_meta_flagged_modified: z.number(),
  defect_dataset_meta_flagged_modified: z.number(),
  qa_action_log_rows_written: z.number(),
});

export type RegionMergeResult = z.infer<typeof RegionMergeResultSchema>;

export const ObjectTypeMergeExecuteResultSchema = z.object({
  source_type_id: z.number(),
  target_type_id: z.number(),
  overall_status: z.enum(["ok", "partial_failure", "failed"]),
  regions: z.array(RegionMergeResultSchema),
});

export type ObjectTypeMergeExecuteResult = z.infer<
  typeof ObjectTypeMergeExecuteResultSchema
>;
